// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1QCzA","calendarButtons":"ClockData_calendarButtons__iqMX1"};